// extracted by mini-css-extract-plugin
export default {"header":"Header-module__header--Sdz_S","redesignEnabled":"Header-module__redesignEnabled--OIGdA","previewLabel":"Header-module__previewLabel--mn7rE"};